module.exports = __webpack_public_path__ + "img/green.5c594bd2.jpg";